<script>
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import { tweened } from "svelte/motion"
  import Footer from "../components/Footer.svelte"
  import Header from "../components/Header.svelte"
  import Sidebar from "../components/Sidebar.svelte"
  import { verifySession } from "../services/verifySession"
  import { user } from "../stores/User"
  import { BASE_URL } from "../stores/BASE_URL"
  import Container from "../components/Container.svelte"

  let isLoading = false

  let claves = {
    clave_actual: {
      value: "",
      error: false,
      message: "",
    },
    clave_nueva: {
      value: "",
      error: false,
      message: "",
    },
    clave_nueva_confirmacion: {
      value: "",
      error: false,
      message: "",
    },
  }

  let isCorrect = true

  const validar = () => {
    isCorrect = true

    // Validar campos vacios
    if (claves.clave_actual.value.trim() === "") {
      claves.clave_actual.error = true
      claves.clave_actual.message = "Campo vacio"
      isCorrect = false
    } else {
      claves.clave_actual.error = false
      claves.clave_actual.message = ""
    }

    if (claves.clave_nueva.value.trim() === "") {
      claves.clave_nueva.error = true
      claves.clave_nueva.message = "Campo vacio"
      isCorrect = false
    } else {
      claves.clave_nueva.error = false
      claves.clave_nueva.message = ""
    }

    if (claves.clave_nueva_confirmacion.value.trim() === "") {
      claves.clave_nueva_confirmacion.error = true
      claves.clave_nueva_confirmacion.message = "Campo vacio"
      isCorrect = false
    } else {
      claves.clave_nueva_confirmacion.error = false
      claves.clave_nueva_confirmacion.message = ""
    }

    // Validar claves iguales
    if (claves.clave_nueva.value !== claves.clave_nueva_confirmacion.value) {
      claves.clave_nueva_confirmacion.error = true
      claves.clave_nueva_confirmacion.message = "Claves no coinciden"
      isCorrect = false
    } else {
      if (!claves.clave_nueva_confirmacion.error) {
        claves.clave_nueva_confirmacion.error = false
        claves.clave_nueva_confirmacion.message = ""
      }
    }
    // Validar clave actual

    // Validar clave nueva
    if (!validarCaracteres(claves.clave_nueva.value)) {
      claves.clave_nueva.error = true
      claves.clave_nueva.message =
        "La clave debe tener al menos 10 caracteres, una letra mayúscula, una letra minúscula, un número y un caracter especial"
      isCorrect = false
    } else {
      claves.clave_nueva.error = false
      claves.clave_nueva.message = ""
    }

    console.log(isCorrect)
    return isCorrect
  }

  const validarCaracteres = (clave) => {
    let re = /^(?=.*\d)(?=(.*[!*/#%@$_&-]){2,})(?=.*[a-z])(?=.*[A-Z]).{10,}$/
    return re.test(clave)
  }

  // const actualizarClave = async () => {
  //   reiniciarTiempo()
  //   isLoading = true
  //   if (validar()) {
  //     let formData = new FormData()
  //     formData.append("usuario", $user.usuario)
  //     formData.append("clave", claves.clave_actual.value)
  //     formData.append("clave_nueva", claves.clave_nueva.value)
  //     formData.append("session_key", $user.session_key)
  //     formData.append("ops", "actualizarClave")
  //     const response = await fetch(`${BASE_URL}session.php`, {
  //       method: "POST",
  //       body: formData,
  //     })
  //     const resp = await response.json()
  //     if (resp.status === "ok") {
  //       setTimeout(() => {
  //         navigate("/", {
  //           replace: true,
  //         })
  //       }, 1000)
  //     } else {
  //       claves.clave_actual.error = true
  //       claves.clave_actual.message = "Clave incorrecta"
  //     }
  //   }
  //   isLoading = false
  // }

  const actualizarClave = async () => {
    reiniciarTiempo()
    isLoading = true

    let formData = new FormData()
    formData.append("usuario", $user.usuario)
    formData.append("celular", $user.celular)
    formData.append("clave", claves.clave_actual.value)
    formData.append("session_key", $user.session_key)
    formData.append("ops", "actualizarClave")
    const response = await fetch(`${BASE_URL}session.php`, {
      method: "POST",
      body: formData,
    })
    const resp = await response.json()
    if (resp.status === "ok") {
      setTimeout(() => {
        navigate("/", {
          replace: true,
        })
      }, 1000)
    } else {
      claves.clave_actual.error = true
      claves.clave_actual.message = resp.message
    }

    isLoading = false
  }

  const cancelar = () => {
    reiniciarTiempo()
    claves = {
      clave_actual: {
        value: "",
        error: false,
        message: "",
      },
      clave_nueva: {
        value: "",
        error: false,
        message: "",
      },
      clave_nueva_confirmacion: {
        value: "",
        error: false,
        message: "",
      },
    }
  }

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    } else {
      verifySession($user.session_key)

      //Pass
      if ($user.actualizar_clave == "1") {
        navigate("/seguridad", { replace: true })
      }

      //C
      if ($user.verificar == "1") {
        navigate("/verificar", { replace: true })
      }
    }

    if (!$user.permisos.includes("configuracion")) {
      user.setUser(null)
      navigate("/", { replace: true })
    }
  })

  // Tiempo de sessión
  let original = 20 * 60
  let timer = tweened(original)

  setInterval(() => {
    if ($timer > 0) $timer--
  }, 1000)

  $: minutes = Math.floor($timer / 60)

  $: if (minutes <= 0) {
    user.setUser(null)
    navigate("/", { replace: true })
  }

  const reiniciarTiempo = () => {
    timer = tweened(original)
  }
</script>

{#if $user}
  <main class="d-flex flex-column md:flex-row min-vh-100">
    <Sidebar />

    <div class="d-flex flex-column flex-grow-1 page-content">
      <Header />

      <div class="container-fluid bg-2 flex-grow-1 py-5">
        <div class="row h-100">
          <div class="col-12 md:col-12 lg:col-8 xl:col-6 2xl:col-4">
            <Container>
              <h4 class="mb-3">
                <i
                  class="bi bi-shield-lock fg-secondary me-1"
                  aria-hidden="true"
                ></i>
                Cambiar clave
              </h4>
              <p class="form-text fg-secondary small mb-3 text-small">
                Ingrese su clave actual para generar una nueva clave de acceso.
                La nueva clave será enviada por mensaje de texto al celular
                registrado.
              </p>

              {#if $user.celular.length == 6}
                <div class="mb-3">
                  <label class="d-block">
                    <span class="form-label small fg-secondary">
                      Clave actual
                    </span>
                    <input
                      type="password"
                      class="form-control form-control-sm"
                      bind:value={claves.clave_actual.value}
                    />
                  </label>
                  {#if claves.clave_actual.error}
                    <div class="form-text fg-danger">
                      <small>{claves.clave_actual.message}</small>
                    </div>
                  {/if}
                </div>

                <div
                  class="alert theme-warning d-flex align-items-center mb-3"
                  role="alert"
                >
                  <i class="bi bi-info-circle fs-lg me-3" aria-hidden="true"
                  ></i>
                  <p class="form-label small fg-secondary text-small mb-0">
                    La nueva clave se enviará por mensaje de texto (SMS) al
                    número de celular terminado en: <strong>
                      *** {$user.celular.slice(-6, -3)}
                      {$user.celular.slice(-3)}
                    </strong>
                  </p>
                </div>

                <div class="d-flex gap-3 justify-content-end mb-3">
                  <button
                    class="btn btn-solid theme-neutral btn-sm"
                    on:click={cancelar}
                  >
                    Cancelar
                  </button>
                  {#if isLoading}
                    <button class="btn btn-solid theme-primary btn-sm disabled">
                      <i class="bi bi-key"></i> Enviando nueva clave...
                    </button>
                  {:else}
                    <button
                      class="btn btn-solid theme-primary btn-sm"
                      on:click={actualizarClave}
                    >
                      <i class="bi bi-key"></i> Generar y enviar nueva clave
                    </button>
                  {/if}
                </div>
              {:else}
                <div class="mb-3">
                  <p class="form-label small fg-secondary">
                    Para cambiar su clave, por favor contacte a su ejecutivo
                    comercial y actualice su celular.
                  </p>
                </div>
              {/if}
            </Container>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </main>
{/if}
